
import _ from "underscore";
import templateUrl from 'emun.vendor/file-import/aws-s3-objects.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import ServiceBus from "servicestack/service-bus";
import modals from 'webmodals/modals';
import 'servicestack/file-import/file-imports.client.scss'

class AWSS3ObjectsController {
    constructor($scope) { 
        let $ctrl = this;
        basicController($ctrl);
		$ctrl.bus = new ServiceBus();
        $scope.$watch('$ctrl.startsWith', function() {
            $ctrl.loadObjects();
        });
        $ctrl.$on("$documentUploaded", function() {
            $ctrl.loadObjects();
        })
    }
	$onInit() {
		const $ctrl = this;
	}
    loadObjects(token) {
        const $ctrl = this;
        if (!token) $ctrl.s3objects = [];
        $ctrl.bus.send("AWS/ListS3Objects.json", {
            BucketName: $ctrl.bucketName,
            StartsWith: $ctrl.startsWith,
            ContinuationToken: token,
            MaxKeys: 1000
        }).then(function(args) {
            if (args.data) {
                args.data.s3Objects.map(o => {
                    o.name = o.key.split(/[/\\]/).pop(); 
                    o.url = "https://" + $ctrl.bucketName + ".s3.us-east-1.amazonaws.com/" + o.key;
                    if (o.name) $ctrl.s3objects.push(o);
                });
                if (args.data.nextContinuationToken) $ctrl.loadObjects(args.data.nextContinuationToken);
            }
        });
    }
	openDocument(doc) {
        let $ctrl = this;
        $ctrl.bus.send("AWS/GetPresignedUrl.json", {
            BucketName: $ctrl.bucketName,
            Key: obj.key
        }).then(function(res) {
            window.open(res.data);
        });
	}
    downloadObject(obj) {
        let $ctrl = this;
        $ctrl.bus.send("AWS/GetPresignedUrl.json", {
            BucketName: $ctrl.bucketName,
            Key: obj.key
        }).then(function(res) {
            window.open(res.data);
        });
    }
}

let AWSS3Objects = {
    bindings: {
        bucketName: '@',
        startsWith: '@'
    },
    controller: AWSS3ObjectsController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default AWSS3Objects